export default {
  redeemCode: {
    title: '코드 교환',
    description: '아래에 교환 코드를 입력하여 보상을 받으세요.',
    enterTip: '보상을 받으려면 교환 코드를 입력하세요',
    label: '교환 코드',
    placeholder: '교환 코드 입력',
    submit: '교환',
    redeemBtn: '교환',
    submitting: '교환 중...',
    success: '코드가 성공적으로 교환되었습니다!',
    redeemSuccess: '코드가 성공적으로 교환되었습니다!',
    failed: '코드 교환에 실패했습니다. 다시 시도해 주세요.',
    redeemFailed: '코드 교환에 실패했습니다. 다시 시도해 주세요.'
  }
};
